import { type CSSProperties } from 'react';
import * as lucide from 'lucide-react';

interface Props {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: CSSProperties;
}

function toPascal(name: string) {
  return name
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('');
}

export default function DsIcon({ name, size = 18, strokeWidth = 1.5, className, style }: Props) {
  const lib = lucide as unknown as Record<string, lucide.LucideIcon | undefined>;
  const Comp = lib[toPascal(name)] ?? lucide.Circle;
  return (
    <Comp
      size={size}
      strokeWidth={strokeWidth}
      absoluteStrokeWidth
      className={`ds-icon ${className ?? ''}`}
      style={style}
    />
  );
}
